import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import {Switch, Space} from "antd";
import {
    getAllStores,
    clear_stores,
    createStore,
    CREATE_STORE,
    updateStore,
    UPDATE_STORE
} from "../../../redux/stores";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SelectInput from "../../../components/select";
import Footer from "../../../components/footer";

const Stores = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_stores = useSelector((state) => state.stores_module._get_all_stores);
    const _create_store = useSelector((state) => state.stores_module._create_store);
    const _update_store = useSelector((state) => state.stores_module._update_store);

    const _get_all_cities = useSelector((state) => state.cities_module._get_all_cities);
    const _get_all_zones = useSelector((state) => state.zones_module._get_all_zones);
    const _get_all_societies = useSelector((state) => state.societies_module._get_all_societies);

    const [data, setData] = useState([]);

    useEffect(() => {
        if (_get_all_stores.data.datos) {
            setData(_get_all_stores.data.datos);
        }
    }, [_get_all_stores]);

    const [cities, setCities] = useState([]);

    useEffect(() => {
        if (_get_all_cities && _get_all_cities.data && _get_all_cities.data.datos) {
            let value = _get_all_cities.data.datos.filter(x => x.activo === true);
            setCities(value);
        }
    }, [_get_all_cities]);

    const [zones, setZones] = useState([]);

    useEffect(() => {
        if (_get_all_zones && _get_all_zones.data && _get_all_zones.data.datos) {
            let value = _get_all_zones.data.datos.filter(x => x.activo === true);
            setZones(value);
        }
    }, [_get_all_zones]);

    const [societies, setSocieties] = useState([]);

    useEffect(() => {
        if (_get_all_societies && _get_all_societies.data && _get_all_societies.data.datos) {
            setSocieties(_get_all_societies.data.datos);
        }
    }, [_get_all_societies]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        codigo: "",
        nombre: "",
        correo: "",
        ciudad: "",
        id_ciudad: 0,
        zona: "",
        id_zona: 0,
        sociedad: "",
        id_sociedad: 0,
        activo: true,
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_stores').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        console.log('item')
                        console.log(item.correo)
                        setForm({
                            ...form,
                            codigo: item.codigo,
                            nombre: item.nombre,
                            correo: item.correo !== null ? item.correo : '',
                            ciudad: item.ciudad,
                            id_ciudad: item.id_ciudad,
                            zona: item.zona,
                            id_zona: item.id_zona,
                            sociedad: item.sociedad,
                            id_sociedad: item.id_sociedad,
                            activo: item.activo
                        });
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        if (e.target.name === "id_ciudad" || e.target.name === "id_zona" || e.target.name === "id_sociedad") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    useEffect(() => {
        if (_create_store.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_stores(CREATE_STORE));
            dispatch(getAllStores(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_store.status !== 0) {
            dispatch(clear_stores(CREATE_STORE));
            toast.error(_create_store.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_store, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_store.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_stores(UPDATE_STORE));
            dispatch(getAllStores(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_store.status !== 0) {
            dispatch(clear_stores(UPDATE_STORE));
            toast.error(_update_store.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_store, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.codigo === "") {
            toast.error("Debe ingresar el código", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.correo === "") {
            toast.error("Debe ingresar el correo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_sociedad === 0) {
            toast.error("Debe seleccionar una sociedad", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_ciudad === 0) {
            toast.error("Debe seleccionar una ciudad y municipio", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_zona === 0) {
            toast.error("Debe seleccionar una zona", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(createStore(token, form));
        } else {
            dispatch(updateStore(token, id, form));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Tiendas", link: "/tiendas"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_stores').length > 0 ?
                                        <Button type="button" text="Crear" theme="calendar" onClick={() => {
                                            setModal(true);
                                            setForm({
                                                ...form,
                                                codigo: '',
                                                nombre: '',
                                                correo: '',
                                                ciudad: '',
                                                id_ciudad: 0,
                                                zona: '',
                                                id_zona: 0,
                                                sociedad: '',
                                                id_sociedad: 0,
                                                activo: true
                                            });
                                            document.getElementById('id_sociedad').selectedIndex = 0;
                                            document.getElementById('id_ciudad').selectedIndex = 0;
                                            document.getElementById('id_zona').selectedIndex = 0;
                                            setId(0);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "correo",
                                                label: "Correo",
                                                type: "text",
                                            },
                                            {
                                                name: "sociedad",
                                                label: "Sociedad",
                                                type: "text",
                                            },
                                            {
                                                name: "ciudad",
                                                label: "Ciudad y municipio",
                                                type: "text",
                                            },
                                            {
                                                name: "zona",
                                                label: "Zona",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">{id === 0 ? 'Crear ' : 'Editar '} tienda</h5>
                        <div className="form-group">
                            <Input
                                label="Código"
                                name="codigo"
                                value={form.codigo}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Nombre"
                                name="nombre"
                                value={form.nombre}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Correo"
                                name="correo"
                                value={form.correo}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Sociedad</label>
                            <SelectInput
                                id="id_sociedad"
                                label="Sociedad"
                                name="id_sociedad"
                                value={form.id_sociedad}
                                select={form.sociedad}
                                onChange={handleChange}
                                options={societies ? societies.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                        <div className="form-group">
                            <label>Ciudad y municipio</label>
                            <SelectInput
                                id="id_ciudad"
                                label="Ciudad y municipio"
                                name="id_ciudad"
                                value={form.id_ciudad}
                                select={form.ciudad}
                                onChange={handleChange}
                                options={cities ? cities.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                        <div className="form-group">
                            <label>Zona</label>
                            <SelectInput
                                id="id_zona"
                                label="Zona"
                                name="id_zona"
                                value={form.id_zona}
                                select={form.zona}
                                onChange={handleChange}
                                options={zones ? zones.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                        {id !== 0 &&
                            <div className="form-group">
                                <Space size={14} direction='horizontal'>
                                    <strong>Activo</strong>
                                    <Switch
                                        checked={form.activo}
                                        checkedChildren="SI"
                                        unCheckedChildren="NO"
                                        onChange={handleCheckedChange}
                                    />
                                </Space>
                            </div>
                        }
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-calendar mb-1 button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default Stores;
